import MicOffOutlinedIcon from "@mui/icons-material/MicOffOutlined";
import type { NetworkQuality } from "@zoom/videosdk";
import classNames from "classnames";
import { CSSProperties, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Flex from "../../../components/Flex";
import { RootState } from "../../../redux/store";
import { Participant } from "../../index-types";
import "./avatar.scss";
interface AvatarProps {
  participant: Participant;
  style?: CSSProperties;
  isActive: boolean;
  className?: string;
  networkQuality?: NetworkQuality;
}
const Avatar = (props: AvatarProps) => {
  const { participant, style, isActive, className } = props;
  const { displayName, audio, muted, bVideoOn, isInFailover } = participant;
  const [fontSize, setFontSize] = useState(38);
  const avatarRef = useRef(null);

  useLayoutEffect(() => {
    if (avatarRef.current) {
      const { width } = (
        avatarRef.current as HTMLDivElement
      ).getBoundingClientRect();
      setFontSize(
        Math.max(12, Math.min(38, Math.ceil(width / displayName.length)))
      );
    }
  }, [displayName]);

  const isMinimizeCall = useSelector(
    (state: RootState) => state.joinRoom.isMinimize
  );

  const defaultStyle = {
    position: "absolute",
    top: 30,
    width: "88%",
    height: "65%",
    left: 30,
  };

  return (
    <Flex
      className={classNames("avatar", { "avatar-active": isActive }, className)}
      style={{
        ...(!isMinimizeCall ? style : (defaultStyle as any)),
        background: bVideoOn
          ? "transparent"
          : isMinimizeCall
            ? "rgb(26,26,26)"
            : "transparent",
      }}
      ref={avatarRef}
    >
      {(bVideoOn || (audio === "computer" && muted) || isInFailover) && (
        <div
          className={isMinimizeCall ? "minimize-window-name" : "center-name"}
        >
          {audio === "computer" && muted && (
            <MicOffOutlinedIcon style={{ color: "#f00" }} />
          )}
          {/* {bVideoOn && networkQuality !== undefined && (
            <IconFont
              type={`icon-network-${
                networkQualityIcons[
                  Math.min(
                    networkQuality?.downlink ?? Number.MAX_VALUE,
                    networkQuality?.uplink ?? Number.MAX_VALUE
                  )
                ]
              }`}
            />
          )} */}
          {/* {isInFailover && (
            <IconFont
              type="icon-reconnect"
              style={{
                color: "#FF9209",
                animation: "loading 3s linear infinite",
              }}
            />
          )} */}
          {bVideoOn && <span>{displayName}</span>}
        </div>
      )}
      {!bVideoOn && (
        <p
          className="center-name"
          style={{ fontSize: isMinimizeCall ? `${fontSize}px` : "20px" }}
        >
          {displayName}
        </p>
      )}
    </Flex>
  );
};

export default Avatar;
